import { AppBar, Button, Dialog, DialogActions, DialogContent, DialogContentText, Toolbar, Typography } from "@material-ui/core";
import React from "react";

function ThankYouAndPatience({successDialog}) {
  return (
    <Dialog
        open={successDialog}
        aria-labelledby={"responsive-dialog-title"}
        maxWidth={"lg"}
    >
        <AppBar
            style={{
                position: "relative",
                backgroundColor: "#064473",
                height: "37px"
            }}
        >
        <Toolbar>
            <Typography
                variant={"h6"}
                style={{
                    textAlign: "center",
                    flex: "1",
                    marginBottom: "9px"
                }}
            >
              {"End Session\r"}
            </Typography>
        </Toolbar>
        </AppBar>
        <DialogContent>
            <DialogContentText>
                <h1>
                <i>
                    <b>
                    {" "}
                    {"Thank you for your patience and cooperation. Have a\r"}
                    {"wonderful day!\r"}
                    </b>
                </i>
                </h1>
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <div className={"row"}>
                <div className={"col-xs-12 end-xs req-btn"}>
                <Button
                    onClick={() => window.location.reload()}
                    variant={"contained"}
                >
                    {"Ok\r"}
                </Button>
                </div>
            </div>
        </DialogActions>
    </Dialog>
  );
}

export default ThankYouAndPatience;
